// extracted by mini-css-extract-plugin
var _1 = "ColorLayer-modulecolorLayer__D_Ze9";
export { _1 as "colorLayer" }
